import React from "react";
import {
  Badge,
  Box,
  IconButton,
  styled,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import TableChartIcon from "@mui/icons-material/TableChartOutlined";
import {
  BodySmall,
  H7TitleLarge,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { ManageColumns } from "./ManageColumns/ManageColumns.js";
import MinerFilters from "./MinerFilters/MinerFilters.js";
import useSiteAndGroupTreeContext from "../../context/useSiteAndGroupTreeContext.js";
import { useGetSiteLists } from "../../../api/queries/useGetSiteLists.ts";
import { isEmpty } from "lodash";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

const CustomBadge = styled(Badge)(({ colors }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: colors?.text?.primary, 
    color: colors?.primary?.contrastText, 
    fontSize: "0.75rem", // Optional: Adjust font size
    padding: "0.25rem", // Optional: Adjust padding
  },
}));

export const MinerTableHeader = React.memo((props) => {
  const {
    setRightSidePanelOpen,
    rightSidePanelOpen,
    gridRef,
    totalCount,
    authToken,
    setLeftSidePanelOpen,
  } = props;
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const { colors } = useTheme();
  const {
    data: siteLists,
    isLoading: isSiteGroupDataLoading,
    isFetching: isSiteGroupDataFetching,
    isFetched: isSiteGroupDataFetched,
    isRefetching: isSiteGroupDataRefetching,
    refetch,
  } = useGetSiteLists({
    authToken,
    leftPanelOpen: true,
  });

  const sites =
    isSiteGroupDataFetched && siteLists?.siteList
      ? siteLists.siteList
      : [];

  return (
    <Box
      className={"table-container-header"}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <CustomBadge
        colors={colors}
        badgeContent={totalCount}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{}}
        max={1000000}
      >
        <Box pr={3}>
          <H7TitleLarge> All miners</H7TitleLarge>
        </Box>
      </CustomBadge>
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={2}
        alignItems={"center"}
      >
        <MinerFilters
          siteListStatus={
            !isEmpty(siteLists) ? siteLists?.status : ""
          }
        />
        <ManageColumns
          siteListStatus={
            !isEmpty(siteLists) ? siteLists?.status : ""
          }
        />
        <Tooltip
          title={
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="row"
              sx={{ textAlign: "center" }}
            >
              <BodySmall sx={{ color: "white" }}>
                Click
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontSize: "0.875rem",
                    verticalAlign: "middle",
                    color: "white",
                    margin: "0 0.2rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setLeftSidePanelOpen(true);
                  }}
                >
                  right_panel_close
                </span>{" "}
                icon to select group or site
              </BodySmall>
            </Box>
          }
          arrow
        >
          <span>
            <StyledIconButton
              colors={colors}
              disabled={
                (siteSelectedName === "" &&
                  groupSelectedName === "") ||
                siteLists?.status !== "ok"
              }
              onClick={() =>
                setRightSidePanelOpen((prev) => {
                  if (!prev === false && gridRef?.current) {
                    gridRef.current = null;
                  }
                  return !prev;
                })
              }
            >
              <KeyboardDoubleArrowLeftOutlinedIcon
                fontSize={"medium"}
                sx={{
                  color:
                    (siteSelectedName === "" &&
                      groupSelectedName === "") ||
                    siteLists?.status !== "ok"
                      ? colors.text.disabled
                      : colors.text.muted,
                  transform: rightSidePanelOpen
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
                }}
              />
            </StyledIconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
});
